import { render, staticRenderFns } from "./SlidePagination.vue?vue&type=template&id=6cf6371b"
import script from "./SlidePagination.vue?vue&type=script&lang=js"
export * from "./SlidePagination.vue?vue&type=script&lang=js"
import style0 from "./SlidePagination.vue?vue&type=style&index=0&id=6cf6371b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports